module.exports = __webpack_public_path__ + "static/media/phone-top-mode.03310ff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/contents/img/phone-top-mode.png
// module id = 3319
// module chunks = 0